import humanizeDuration from "humanize-duration";

export const formatDuration = humanizeDuration.humanizer({
  language: "shortEn",
  units: ["h", "m"],
  round: true,
  languages: {
    shortEn: {
      h: () => "hr",
      m: () => "min",
    },
  },
});
